import { Flex } from '@chakra-ui/layout'
import { Box } from 'front-end/src/components'
import React, { ReactElement } from 'react'
import { brandColors } from 'shared/basicPalette'

import './TableExtendedHeader.less'

export interface ITableExtendedHeaderProps {
  title?: string | ReactElement
  description?: string | ReactElement
  filter?: any
}

export function TableExtendedHeader({
  title,
  description,
  filter
}: ITableExtendedHeaderProps) {
  return (
    <header className="TableExtendedHeader">
      <Flex direction="column">
        {title && (
          <Box as="h2" mr="8px">
            {title}
          </Box>
        )}
        {description && (
          <Box mt="4px" color={brandColors.grey[500]}>
            {description}
          </Box>
        )}
      </Flex>
      {filter}
    </header>
  )
}
